// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --l: 2.75em;
  --t: 5s;
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-out;
  /* Isolate rendering context for better performance */
  isolation: isolate;
  /* GPU acceleration */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  will-change: opacity;
}

.loading-screen.fade-out {
  opacity: 0;
  pointer-events: none;
}

.loading-screen,
.loading-screen * {
  box-sizing: border-box;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  width: 100%;
  height: 100%;
  padding: 2rem;
}

/* Logo Container */
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 1;
  flex-shrink: 0;
}

.logo-wrapper {
  position: relative;
  width: 300px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-image {
  width: 100%;
  height: auto;
  max-width: 300px;
  opacity: 0;
  animation: logoWrite 3.5s ease-in-out forwards;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.15));
}

/* Writing Animation - Similar to CodePen */
@keyframes logoWrite {
  0% {
    opacity: 0;
    clip-path: inset(0 100% 0 0);
    filter: blur(8px);
  }
  15% {
    opacity: 0.3;
    filter: blur(4px);
  }
  30% {
    opacity: 0.6;
    clip-path: inset(0 50% 0 0);
    filter: blur(2px);
  }
  50% {
    opacity: 0.8;
    clip-path: inset(0 25% 0 0);
    filter: blur(1px);
  }
  70% {
    opacity: 0.9;
    clip-path: inset(0 10% 0 0);
    filter: blur(0.5px);
  }
  85% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
    filter: blur(0);
  }
  100% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
    filter: blur(0);
  }
}

.cube-animation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
}

.grid {
  grid-template-columns: repeat(var(--n), var(--l));
  grid-gap: 0.5em;
  place-self: center;
  transform: rotateX(55deg) rotate(45deg);
  transform-style: preserve-3d;
  display: grid;
  /* GPU acceleration optimizations */
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.cube {
  aspect-ratio: 1;
  transform-origin: 50% 50% calc(-1 * var(--l));
  background: #fff;
  animation: ani var(--t) ease-in-out infinite;
  animation-delay: calc((var(--n) - 1 - var(--j) + var(--i)) * 0.05 * var(--t));
  transform-style: preserve-3d;
  position: relative;
  /* GPU acceleration optimizations */
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.cube::before,
.cube::after {
  --i: 0;
  --j: calc(1 - var(--i));
  grid-area: 1 / 1;
  transform-origin: calc(var(--j) * 50%) calc(var(--i) * 50%);
  translate: calc(var(--i) * 100%) calc(var(--j) * 100%);
  rotate: var(--j) var(--i) 0 calc((2 * var(--i) - 1) * 90deg);
  background: color-mix(in hsl, #a9a9a9 calc(var(--i) * 100%), #dcdcdc);
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* GPU acceleration optimizations */
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.cube::after {
  --i: 1;
}

@keyframes ani {
  0%, 50%, 100% {
    scale: 1 1 0;
  }
  25% {
    scale: 1 1 0.5;
  }
}

/* Fallback for browsers that don't support color-mix */
@supports not (color-mix(in hsl, #a9a9a9 100%, #dcdcdc)) {
  .cube::before {
    background: #a9a9a9;
  }
  .cube::after {
    background: #dcdcdc;
  }
}

/* Only prevent scrolling when loading screen is active */
body.loading-active {
  overflow: hidden;
  height: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/components/layout/LoadingScreen.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,iCAAiC;EACjC,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,aAAa;EACb,mCAAmC;EACnC,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,6EAA6E;EAC7E,4BAA4B;EAC5B,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;EAEE,MAAM;EACN,uBAAuB;EACvB,gBAAgB;EAChB,2DAA2D;EAC3D,sDAAsD;EACtD,4DAA4D;EAC5D,qEAAqE;EACrE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mCAAmC;EACnC,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,MAAM;AACR;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[":root {\n  --l: 2.75em;\n  --t: 5s;\n}\n\n.loading-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  opacity: 1;\n  transition: opacity 0.5s ease-out;\n  /* Isolate rendering context for better performance */\n  isolation: isolate;\n  /* GPU acceleration */\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  will-change: opacity;\n}\n\n.loading-screen.fade-out {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.loading-screen,\n.loading-screen * {\n  box-sizing: border-box;\n}\n\n.loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n}\n\n/* Logo Container */\n.logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  z-index: 1;\n  flex-shrink: 0;\n}\n\n.logo-wrapper {\n  position: relative;\n  width: 300px;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo-image {\n  width: 100%;\n  height: auto;\n  max-width: 300px;\n  opacity: 0;\n  animation: logoWrite 3.5s ease-in-out forwards;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.15));\n}\n\n/* Writing Animation - Similar to CodePen */\n@keyframes logoWrite {\n  0% {\n    opacity: 0;\n    clip-path: inset(0 100% 0 0);\n    filter: blur(8px);\n  }\n  15% {\n    opacity: 0.3;\n    filter: blur(4px);\n  }\n  30% {\n    opacity: 0.6;\n    clip-path: inset(0 50% 0 0);\n    filter: blur(2px);\n  }\n  50% {\n    opacity: 0.8;\n    clip-path: inset(0 25% 0 0);\n    filter: blur(1px);\n  }\n  70% {\n    opacity: 0.9;\n    clip-path: inset(0 10% 0 0);\n    filter: blur(0.5px);\n  }\n  85% {\n    opacity: 1;\n    clip-path: inset(0 0 0 0);\n    filter: blur(0);\n  }\n  100% {\n    opacity: 1;\n    clip-path: inset(0 0 0 0);\n    filter: blur(0);\n  }\n}\n\n.cube-animation-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.grid {\n  grid-template-columns: repeat(var(--n), var(--l));\n  grid-gap: 0.5em;\n  place-self: center;\n  transform: rotateX(55deg) rotate(45deg);\n  transform-style: preserve-3d;\n  display: grid;\n  /* GPU acceleration optimizations */\n  will-change: transform;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n.cube {\n  aspect-ratio: 1;\n  transform-origin: 50% 50% calc(-1 * var(--l));\n  background: #fff;\n  animation: ani var(--t) ease-in-out infinite;\n  animation-delay: calc((var(--n) - 1 - var(--j) + var(--i)) * 0.05 * var(--t));\n  transform-style: preserve-3d;\n  position: relative;\n  /* GPU acceleration optimizations */\n  will-change: transform;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n}\n\n.cube::before,\n.cube::after {\n  --i: 0;\n  --j: calc(1 - var(--i));\n  grid-area: 1 / 1;\n  transform-origin: calc(var(--j) * 50%) calc(var(--i) * 50%);\n  translate: calc(var(--i) * 100%) calc(var(--j) * 100%);\n  rotate: var(--j) var(--i) 0 calc((2 * var(--i) - 1) * 90deg);\n  background: color-mix(in hsl, #a9a9a9 calc(var(--i) * 100%), #dcdcdc);\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  /* GPU acceleration optimizations */\n  will-change: transform;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n.cube::after {\n  --i: 1;\n}\n\n@keyframes ani {\n  0%, 50%, 100% {\n    scale: 1 1 0;\n  }\n  25% {\n    scale: 1 1 0.5;\n  }\n}\n\n/* Fallback for browsers that don't support color-mix */\n@supports not (color-mix(in hsl, #a9a9a9 100%, #dcdcdc)) {\n  .cube::before {\n    background: #a9a9a9;\n  }\n  .cube::after {\n    background: #dcdcdc;\n  }\n}\n\n/* Only prevent scrolling when loading screen is active */\nbody.loading-active {\n  overflow: hidden;\n  height: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
